import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../../store/actions/system.actions'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomMultiSelect,
  CustomPanel,
  CustomTabView,
  HeaderText,
  InputNumeroInteiro,
  PageHeader,
} from '../../../../../../components'
import useMovimentacaoExpedicaoExpedir, {
  LOAD_MESSAGE,
} from './MovimentacaoEstoqueExpedicaoExpedirHook'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../../assets/js/styles'
import './MovimentacaoEstoqueExpedicaoExpedir.css'
import { TabPanel } from 'primereact/tabview'

function MovimentacaoEstoqueExpedicaoExpedir({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMovimentacaoExpedicaoExpedir()
  const { selectedMovimentacao } = history.location.state

  // Aba principal: 0 = Produtos para Expedir, 1 = Pallets/Produtos em Estoque
  const [activeMainTab, setActiveMainTab] = useState(0)

  useEffect(() => {
    localDispatch.onInit(selectedTp, selectedMovimentacao.id)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      case LOAD_MESSAGE.GET_ESTOQUES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getEstoquesFromTp(selectedTp)
        break

      case LOAD_MESSAGE.ASSOC_FIFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.assocAutomaticoFifo(
          selectedMovimentacao.id,
          selectedTp,
          state.selectedEstoquesAutomatico,
        )
        break

      case LOAD_MESSAGE.PRODUCTS:
        localDispatch.getProdutosExpedicao(selectedTp, selectedMovimentacao.id)
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      case LOAD_MESSAGE.PRODUCTS_FROM_STOCK:
        localDispatch.getProdutosEstoque(
          selectedTp,
          selectedMovimentacao.id,
          state.selectedProduto.product_id,
        )
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      case LOAD_MESSAGE.PALLETS_FROM_STOCK:
        localDispatch.getProdutosPalletsEstoque(
          selectedTp,
          selectedMovimentacao.id,
          state.selectedProduto.product_id,
        )
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, {
        selectedMovimentacao: state.selectedMovimentacao,
      })
    }
  }, [state.pathToRedirect])

  return (
    <div>
      <PageHeader>8.5 - Movimentacao de Estoque - Expedir</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={localDispatch.onBtnNovo} showBtnNovo={false} onVoltar={history.goBack}>
          <CustomTabView activeIndex={activeMainTab} onTabChange={setActiveMainTab}>
            <TabPanel header="Produtos para Expedir">
              <div className="p-grid">
                <div className="p-col-12">
                  <HeaderText>Produtos à serem Expedidos</HeaderText>

                  <DataTable
                    value={state.produtosParaExpedir}
                    header={
                      <CustomDataTableHeader
                        onChange={value => localDispatch.onChange('globalFilter', value)}
                      />
                    }
                    selection={state.selectedProduto}
                    onSelectionChange={e => {
                      localDispatch.onChange('selectedProduto', e.value)
                      setActiveMainTab(e.value ? 1 : 0)
                    }}
                    globalFilter={state.globalFilter}
                    paginator={true}
                    rows={10}
                    rowClassName={rowData => ({ 'row-warning': rowData.qte_faltante })}
                  >
                    <Column selectionMode="single" style={{ width: '5em' }} />
                    <Column
                      field="product_code"
                      header="Código"
                      style={tableCellCentered()}
                      sortable
                    />
                    <Column
                      field="product_name"
                      header="Produto"
                      style={tableCellCentered(180)}
                      sortable
                    />
                    <Column
                      field="quantidade"
                      header="Qte Total"
                      style={tableCellCentered(80)}
                      sortable
                    />
                    <Column
                      field="qte_faltante"
                      header="Qte Faltante"
                      style={tableCellCentered(80)}
                      sortable
                    />
                    <Column
                      field="validade"
                      sortField="validade_sort"
                      header="Validade"
                      style={tableCellCentered(150)}
                      sortable
                    />
                    <Column field="lote" header="Lote" style={tableCellCentered(150)} sortable />
                  </DataTable>
                </div>
              </div>
            </TabPanel>

            <TabPanel header="Pallets/Produtos em Estoque">
              <div className="p-grid">
                <div className="p-col-12">
                  <div
                    style={{
                      position: 'sticky',
                      top: 0,
                      zIndex: 2,
                      background: '#fff',
                      padding: '8px 12px',
                      border: '1px solid #e5e7eb',
                      borderRadius: 6,
                      marginBottom: 10,
                      display: 'grid',
                      gridAutoFlow: 'column',
                      gap: 12,
                      alignItems: 'center',
                    }}
                  >
                    {state.selectedProduto ? (
                      <>
                        <div>
                          <b>{state.selectedProduto.product_code}</b> —{' '}
                          {state.selectedProduto.product_name}
                        </div>
                        <div>Qte Total: {state.selectedProduto.quantidade}</div>
                        <div>Qte Faltante: {state.selectedProduto.qte_faltante}</div>
                        <div>Lote: {state.selectedProduto.lote || '-'}</div>
                        <div>Validade: {state.selectedProduto.validade || '-'}</div>
                      </>
                    ) : (
                      <div>Selecione um produto na aba “Produtos para Expedir”.</div>
                    )}
                  </div>
                </div>

                <div className="p-col-3" style={{ marginTop: 10, paddingBottom: 10 }}>
                  <CustomCheckbox
                    onChange={value => localDispatch.onChange('useAlgoritmo', value)}
                    checked={state.useAlgoritmo}
                  >
                    Usar Métodos Automáticos de Associação
                  </CustomCheckbox>
                </div>

                <div className="p-col-3" style={{ display: state.useAlgoritmo ? 'block' : 'none' }}>
                  <CustomMultiSelect
                    label={'Estoque(s)'}
                    options={state.estoques.filter(e => e.id)}
                    onChange={value => localDispatch.onChange('selectedEstoquesAutomatico', value)}
                    value={state.selectedEstoquesAutomatico}
                    optionLabel={'name'}
                    filter={true}
                  />
                </div>

                <div
                  className="p-col-3"
                  style={{
                    marginTop: 0,
                    marginBottom: 10,
                    display: state.useAlgoritmo ? 'block' : 'none',
                  }}
                >
                  <CustomDropdown
                    disabled={!state.useAlgoritmo}
                    label={'Algoritmo'}
                    marginTop={0}
                    placeholder="Selecionar Algoritmo"
                    value={state.selectedAlgoritmo}
                    onChange={value => localDispatch.onChange('selectedAlgoritmo', value)}
                    optionLabel={'name'}
                    options={[{ name: 'FIFO', value: 'FIFO' }]}
                  />
                </div>

                <div
                  className="p-col-3"
                  style={{ paddingTop: 28, display: state.useAlgoritmo ? 'block' : 'none' }}
                >
                  <Btn
                    onClick={() =>
                      localDispatch.efetuarAssocAutomatico(
                        state.selectedAlgoritmo,
                        state.selectedEstoquesAutomatico,
                      )
                    }
                  >
                    Associar
                  </Btn>
                </div>

                <div className="p-col-12" style={{ marginTop: -8 }}>
                  <HeaderText>Pallets/Produtos em Estoque</HeaderText>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                      margin: '8px 0 12px',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div style={{ minWidth: '300px' }}>
                      <CustomDropdown
                        labelPosition="left"
                        label={'Estoque'}
                        marginTop={0}
                        placeholder="Selecionar Estoque"
                        value={state.selectedEstoque}
                        onChange={value => localDispatch.onChange('selectedEstoque', value)}
                        optionLabel={'name'}
                        options={
                          state.useAlgoritmo ? state.estoquesFilteredByAutomatico : state.estoques
                        }
                      />
                    </div>

                    <Btn
                      disabled={!state.selectedProduto}
                      onClick={() =>
                        localDispatch.onClickExpedir(
                          state.produtosPalletsEstoque,
                          state.produtosEstoque,
                          state.selectedProduto,
                          selectedMovimentacao.id,
                          selectedTp,
                        )
                      }
                    >
                      Salvar
                    </Btn>
                  </div>

                  <CustomTabView
                    activeIndex={state.activeIndex}
                    onTabChange={localDispatch.onTabChange}
                  >
                    <TabPanel header="Etiqueta - Estoque">
                      <div className="p-grid">
                        <div
                          className="p-col-12 p-grid p-justify-center container-items relative scroll"
                          style={{ padding: 0 }}
                        >
                          <DataTable
                            value={localDispatch.filterProdutosByEstoque(
                              state.produtosPalletsEstoque.filter(
                                p => p.pallet_area_id && p.picking_type === 'Recebimento',
                              ),
                              state.selectedEstoque,
                              state.selectedEstoquesAutomatico,
                              state.useAlgoritmo,
                            )}
                            header={
                              <CustomDataTableHeader
                                onChange={value =>
                                  localDispatch.onChange('searchprodutosPalletsEstoque', value)
                                }
                                children={
                                  <>
                                    <div
                                      style={{
                                        width: '100%',
                                        marginTop: 10,
                                        marginBottom: 10,
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'inline-grid',
                                          gap: '10px',
                                          gridAutoFlow: 'column',
                                          marginLeft: 20,
                                        }}
                                      >
                                        <Btn
                                          disabled={
                                            !localDispatch.canAlocar(state.selectedProdutosPallets)
                                          }
                                          onClick={() =>
                                            localDispatch.onClickAlocarPallet(
                                              state.selectedProdutosPallets,
                                              state.selectedProduto,
                                            )
                                          }
                                        >
                                          Alocar
                                        </Btn>
                                        <Btn
                                          disabled={
                                            !localDispatch.canDesalocar(
                                              state.selectedProdutosPallets,
                                            )
                                          }
                                          onClick={() =>
                                            localDispatch.onClickDesalocarPallet(
                                              state.selectedProdutosPallets,
                                            )
                                          }
                                        >
                                          Desalocar
                                        </Btn>
                                      </div>
                                      <div
                                        style={{
                                          display: 'inline-grid',
                                          marginTop: 10,
                                          marginLeft: 15,
                                        }}
                                      >
                                        <span>
                                          Total Selecionado:{' '}
                                          {localDispatch.sumQuantiaSelecionada(
                                            state.selectedProdutosPallets,
                                            state.selectedProdutosEstoque,
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                }
                              />
                            }
                            selection={state.selectedProdutosPallets}
                            onSelectionChange={e =>
                              localDispatch.onChange('selectedProdutosPallets', e.value)
                            }
                            globalFilter={state.searchprodutosPalletsEstoque}
                            paginator={true}
                            rows={10}
                            rowClassName={rowData => ({ 'row-alocated': rowData.alocated })}
                          >
                            <Column selectionMode="multiple" style={{ width: '3em' }} />
                            <Column field="name" header="Produto" sortable />
                            <Column
                              field="quantidade"
                              header="Qte Física"
                              style={tableCellCentered(80)}
                              sortable
                            />
                            <Column
                              field="quantidade_expedicoes"
                              header="Qte Expedições"
                              style={tableCellCentered()}
                              sortable
                            />
                            <Column
                              field="qte_alocar"
                              header="Qte Expedição"
                              style={tableCellCentered()}
                              sortable
                              body={produto => (
                                <InputNumeroInteiro
                                  marginTop={0}
                                  disabled={produto.alocated}
                                  value={produto.qte_alocar}
                                  onChange={value =>
                                    localDispatch.onChangePallet(produto.id, value, 'qte_alocar')
                                  }
                                />
                              )}
                            />
                            <Column
                              field="validade"
                              sortField="validade_sort"
                              header="Validade"
                              sortable
                            />
                            <Column field="lote" header="Lote" sortable />
                            <Column field="pos_estoque" header="Posição" sortable />
                          </DataTable>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel header="Etiqueta - Cross">
                      <div className="p-grid">
                        <div
                          className="p-col-12 p-grid p-justify-center container-items relative scroll"
                          style={{ padding: 0 }}
                        >
                          <DataTable
                            value={localDispatch.filterProdutosByEstoque(
                              state.produtosPalletsEstoque.filter(
                                p => p.pallet_area_id && p.picking_type !== 'Recebimento',
                              ),
                              state.selectedEstoque,
                              state.selectedEstoquesAutomatico,
                              state.useAlgoritmo,
                            )}
                            header={
                              <CustomDataTableHeader
                                onChange={value =>
                                  localDispatch.onChange('searchprodutosPalletsEstoque', value)
                                }
                                children={
                                  <>
                                    <div
                                      style={{
                                        width: '100%',
                                        marginTop: 10,
                                        marginBottom: 10,
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'inline-grid',
                                          gap: '10px',
                                          gridAutoFlow: 'column',
                                          marginLeft: 20,
                                        }}
                                      >
                                        <Btn
                                          disabled={
                                            !localDispatch.canAlocar(state.selectedProdutosPallets)
                                          }
                                          onClick={() =>
                                            localDispatch.onClickAlocarPallet(
                                              state.selectedProdutosPallets,
                                              state.selectedProduto,
                                            )
                                          }
                                        >
                                          Alocar
                                        </Btn>
                                        <Btn
                                          disabled={
                                            !localDispatch.canDesalocar(
                                              state.selectedProdutosPallets,
                                            )
                                          }
                                          onClick={() =>
                                            localDispatch.onClickDesalocarPallet(
                                              state.selectedProdutosPallets,
                                            )
                                          }
                                        >
                                          Desalocar
                                        </Btn>
                                      </div>
                                      <div
                                        style={{
                                          display: 'inline-grid',
                                          marginTop: 10,
                                          marginLeft: 15,
                                        }}
                                      >
                                        <span>
                                          Total Selecionado:{' '}
                                          {localDispatch.sumQuantiaSelecionada(
                                            state.selectedProdutosPallets,
                                            state.selectedProdutosEstoque,
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                }
                              />
                            }
                            selection={state.selectedProdutosPallets}
                            onSelectionChange={e =>
                              localDispatch.onChange('selectedProdutosPallets', e.value)
                            }
                            globalFilter={state.searchprodutosPalletsEstoque}
                            paginator={true}
                            rows={10}
                            rowClassName={rowData => ({ 'row-alocated': rowData.alocated })}
                          >
                            <Column selectionMode="multiple" style={{ width: '3em' }} />
                            <Column field="name" header="Produto" sortable />
                            <Column
                              field="quantidade"
                              header="Qte Física"
                              style={tableCellCentered(80)}
                              sortable
                            />
                            <Column
                              field="quantidade_expedicoes"
                              header="Qte Expedições"
                              style={tableCellCentered()}
                              sortable
                            />
                            <Column
                              field="qte_alocar"
                              header="Qte Expedição"
                              style={tableCellCentered()}
                              sortable
                              body={produto => (
                                <InputNumeroInteiro
                                  marginTop={0}
                                  disabled={produto.alocated}
                                  value={produto.qte_alocar}
                                  onChange={value =>
                                    localDispatch.onChangePallet(produto.id, value, 'qte_alocar')
                                  }
                                />
                              )}
                            />
                            <Column
                              field="validade"
                              sortField="validade_sort"
                              header="Validade"
                              sortable
                            />
                            <Column field="lote" header="Lote" sortable />
                            <Column field="pos_estoque" header="Posição" sortable />
                          </DataTable>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel header="Produtos">
                      <div className="p-grid">
                        <div
                          className="p-col-12 p-grid p-justify-center container-items relative scroll"
                          style={{ padding: 0 }}
                        >
                          <DataTable
                            value={localDispatch.filterProdutosByEstoque(
                              state.produtosEstoque,
                              state.selectedEstoque,
                              state.selectedEstoquesAutomatico,
                              state.useAlgoritmo,
                            )}
                            header={
                              <CustomDataTableHeader
                                onChange={value =>
                                  localDispatch.onChange('searchProdutosExpedicao', value)
                                }
                                children={
                                  <>
                                    <div
                                      style={{
                                        width: '100%',
                                        marginTop: 10,
                                        marginBottom: 10,
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'inline-grid',
                                          gap: '10px',
                                          gridAutoFlow: 'column',
                                          marginLeft: 20,
                                        }}
                                      >
                                        <Btn
                                          disabled={
                                            !localDispatch.canAlocar(state.selectedProdutosEstoque)
                                          }
                                          onClick={() =>
                                            localDispatch.onClickAlocarProduto(
                                              state.selectedProdutosEstoque,
                                              state.selectedProduto,
                                            )
                                          }
                                        >
                                          Alocar
                                        </Btn>
                                        <Btn
                                          disabled={
                                            !localDispatch.canDesalocar(
                                              state.selectedProdutosEstoque,
                                            )
                                          }
                                          onClick={() =>
                                            localDispatch.onClickDesalocarProduto(
                                              state.selectedProdutosEstoque,
                                            )
                                          }
                                        >
                                          Desalocar
                                        </Btn>
                                      </div>
                                      <div
                                        style={{
                                          display: 'inline-grid',
                                          marginTop: 10,
                                          marginLeft: 15,
                                        }}
                                      >
                                        <span>
                                          Total Selecionado:{' '}
                                          {localDispatch.sumQuantiaSelecionada(
                                            state.selectedProdutosPallets,
                                            state.selectedProdutosEstoque,
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                }
                              />
                            }
                            selection={state.selectedProdutosEstoque}
                            onSelectionChange={e =>
                              localDispatch.onChange('selectedProdutosEstoque', e.value)
                            }
                            globalFilter={state.searchProdutosExpedicao}
                            paginator={true}
                            rows={10}
                            rowClassName={rowData => ({ 'row-alocated': rowData.alocated })}
                          >
                            <Column selectionMode="multiple" style={{ width: '3em' }} />
                            <Column field="name" header="Produto" sortable />
                            <Column
                              field="quantidade"
                              header="Qte Total"
                              style={tableCellCentered(80)}
                              sortable
                            />
                            <Column
                              field="quantidade_expedicoes"
                              header="Qte Expedições"
                              style={tableCellCentered()}
                              sortable
                            />
                            <Column
                              field="qte_alocar"
                              header="Qte Expedição"
                              sortable
                              body={produto => (
                                <InputNumeroInteiro
                                  marginTop={0}
                                  value={produto.qte_alocar}
                                  onChange={value =>
                                    localDispatch.onChangeProduto(produto.id, value, 'qte_alocar')
                                  }
                                />
                              )}
                            />
                            <Column
                              field="validade"
                              sortField="validade_sort"
                              header="Validade"
                              sortable
                            />
                            <Column field="lote" header="Lote" sortable />
                            <Column field="pos_estoque" header="Posição" sortable />
                          </DataTable>
                        </div>
                      </div>
                    </TabPanel>
                  </CustomTabView>
                </div>
              </div>
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoEstoqueExpedicaoExpedir))
